<template>
  <div class="row">
    <div class="col-md-4 sidebar">
      <div style="clear: both;"></div>
      <ul class="pt-4">
        <li v-for="video in videos.slice(0, 5)" v-bind:key="video.Id">
          <router-link :to="{ name: 'editClientVideo', params: { id: video._id } }">
            <div class="video">
              <div class="poster" :style="{ background: getPoster(video) }"></div>
              <p>{{ video.name }}</p>
              <p class="time">
                <vue-moments-ago prefix="" suffix="ago" :date="video.date" lang="en" />
              </p>
            </div>
            <div style="clear: both;"></div>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="col-md-8 mt-5">
          <h1>Hello, {{ user.name }}</h1>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import VueMomentsAgo from "vue-moments-ago";

export default {
  components: {
    VueMomentsAgo
  },
  name: "dashboard",
  data: () => ({
    user: {},
    videos: []
  }),

  mounted() {
    axios.get(`${process.env.VUE_APP_API_URL}/api/profile`).then(res => {
      this.user = res.data.user;
    });
    axios.get(`${process.env.VUE_APP_API_URL}/api/clientVideos`).then(res => {
      this.videos = res.data;
    });
  },
  methods: {
    getPoster(video) {
      if (video.poster == undefined) {
        return;
      } else {
        return `url('${process.env.VUE_APP_API_URL}/${video.poster}')`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar {
  background: #f6f8fa;
  height: 100vh;
}
ul {
  list-style-type: none;
  li {
    padding: 10px 0;
  }
  li:hover {
    background: white;
    cursor: pointer;
  }
  .poster {
    height: 80px;
    width: 100px;
    background: gray;
    background-size: 100% 100% !important;
    background-repeat: no-repeat !important;
    background-position: left top !important;
    float: left;
  }
  p {
    margin-left: 115px;
    margin-bottom: 3px;
  }
  .time {
    color: gray;
    font-size: 13px;
  }
}
</style>
